import { render, staticRenderFns } from "./irisSelect.vue?vue&type=template&id=d5ac639c&scoped=true&"
import script from "./irisSelect.vue?vue&type=script&lang=js&"
export * from "./irisSelect.vue?vue&type=script&lang=js&"
import style0 from "./irisSelect.vue?vue&type=style&index=0&id=d5ac639c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ac639c",
  null
  
)

export default component.exports